import React, { useState } from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";
import { deleteProspect } from "../../../services/prospect.service";
import { showSuccess, showError } from "../../../services/toast.service";

const Panel = ({ selectedProspects = [], onDelete }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const count = selectedProspects.length;
  
  if (count === 0) {
    return null;
  }
  
  const handleDelete = async () => {
    setIsDeleting(true);
    
    try {
      // Suppression de chaque prospect sélectionné
      const deletePromises = selectedProspects.map(id => deleteProspect(id));
      await Promise.all(deletePromises);
      
      showSuccess(`${count} candidat${count > 1 ? 's' : ''} supprimé${count > 1 ? 's' : ''} avec succès`);
      
      // Notifier le composant parent que les prospects ont été supprimés
      if (onDelete) {
        onDelete(selectedProspects);
      }
    } catch (error) {
      showError(`Erreur lors de la suppression des candidats: ${error.message}`);
    } finally {
      setIsDeleting(false);
    }
  };
  
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{count} candidat{count > 1 ? 's' : ''}</span> sélectionné{count > 1 ? 's' : ''}
      </div>
      <button 
        className={cn("button-stroke-red", styles.button)} 
        onClick={handleDelete} 
        disabled={isDeleting}
      >
        <Icon name="trash" size="24" />
        <span>{isDeleting ? 'Suppression...' : 'Supprimer'}</span>
      </button>
    </div>
  );
};

export default Panel;
